import { App } from '@amzn/monera-app/lib/pages/_app';

export default App;
